// extracted by mini-css-extract-plugin
export default {"container":"InfoForm_container__8lKdl","row":"InfoForm_row__9wxd9","textField":"InfoForm_textField__TTp+o","label":"InfoForm_label__FU8pb","seat":"InfoForm_seat__JcpjV"};